import { render, staticRenderFns } from "./OnCallDutyCalendar.vue?vue&type=template&id=23a89dd2&"
import script from "./OnCallDutyCalendar.vue?vue&type=script&lang=js&"
export * from "./OnCallDutyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./OnCallDutyCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports